import Fingerprint2 from "fingerprintjs2";

export function getIdentity(): Promise<string> {
  const mDeviceFingerprint = localStorage.getItem("deviceFingerprint");

  if (!mDeviceFingerprint) {
    console.debug("No stored fingerprint found. Generating new fingerprint");

    return new Promise<string>((resolve, reject) => {
      // Wait before generating fingerprint
      console.debug("Waiting 1s before generating fingerprint");
      setTimeout(() => {
        Fingerprint2.getPromise()
          .then(components => {
            // console.debug("Generated fingerprint:", components);

            const values = components.map(component => {
              return component.value;
            });

            const murmur = Fingerprint2.x64hash128(values.join(""), 31);
            console.debug("Saving computed fingeprint:", murmur);
            localStorage.setItem("deviceFingerprint", murmur);
            localStorage.setItem(
              "deviceFingerprintTimestamp",
              new Date().toISOString()
            );
            resolve(murmur);
          })
          .catch(error => {
            console.error("Failed to generate device fingerprint", error);
            reject(error);
          });
      }, 1000);
    });
  } else {
    // console.debug("Found existing fingerprint:", mDeviceFingerprint);
    return new Promise<string>((resolve, reject) => {
      resolve(mDeviceFingerprint);
    });
  }
}



// WEBPACK FOOTER //
// ./src/init/tracking.ts